export const ZoomStep = 50;

export const LandmarkTypesNames = {
    boardPoints: "Boarding Points",
    chargingPoints: "Charging Points",
    normalPoints: "Normal Points",
    waitingPoints: "Waiting Points",
};
